import React, { useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthProvider';
import Translate from '../../../i18n/Translate';
import { UserIcon, LogoutIcon } from '../../../components/icons';

const User = () => {
  const { user, logOut } = useContext(AuthContext);

  if (!user.isAuthenticated) {
    return null;
  }

  return (
    <>
      <div className='userDropdown'>
        <button>
          <UserIcon />
        </button>

        <div className='userDropdown__content'>
          <span className='triangle' />
          <a
            href={`https://witwan.towertravel.com.ar/administracion/reportes/cliente?cred=${user.credentials}`}
            target='_blank'
          >
            <Translate langkey='header.userdropdown.option1' />
          </a>
          <button onClick={logOut}>
            <LogoutIcon />
            <Translate langkey='header.userdropdown.logout' />
          </button>
        </div>
      </div>
    </>
  );
};

export default User;
